<section *ngIf="(seoSummary$ | async)?.description as seoSummaryDesc"
         class="seo-summary"
         aria-label="페이지 소개">
  {{ seoSummaryDesc }}
</section>
<router-outlet></router-outlet>
